import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Base from './../components/base/index';
import rules from './../rules'
import ValidationContext from './../contexts/ValidationContext'

export default function inputFactory(WrappedComponent) {
  return class CustomInput extends Base {
    static displayName = `InputFactory(${WrappedComponent.name})`;

    static propTypes = {
      validations: PropTypes.arrayOf(PropTypes.string).isRequired,
      errorClassName: PropTypes.string,
      containerClassName: PropTypes.string,
      errorContainerClassName: PropTypes.string
    };

    static contextType = ValidationContext;

    constructor(props, context) {
      super(props, context);

      var isCheckbox = !!(props.type === 'checkbox' || props.type === 'radio');
      var checkboxValue = props.checked ? props.value : '';

      // TODO: Refactor conditions
      this.state = {
        value: isCheckbox ? checkboxValue : props.value,
        isChanged: isCheckbox ? props.checked : !!props.value,
        isCheckbox: isCheckbox,
        isUsed: isCheckbox,
        isChecked: isCheckbox ? !!props.checked : true
      };

      context.register(this);
    }

    render() {
      const { validations,
        errorClassName,
        containerClassName,
        errorContainerClassName,
        className,
        value,
        onChange,
        onBlur,
        ...rest } = this.props;

      // TODO: Refactor conditions
      var isInvalid = this.state.isUsed && this.state.isChanged && !!this.context.errors[this.props.name];
      var changedValue = this.state.isCheckbox ? this.props.value : this.state.value;
      var error = isInvalid && this.context.errors[this.props.name][0];
      var hint = null;

      if (isInvalid) {
        hint = typeof error === 'function' 
          ? error(value, this.context.components) 
          : rules[error].hint(value, this.context.components);
      }

      return (
        <WrappedComponent
          {...rest}
          containerClassName={cx({
            [containerClassName]: !!containerClassName,
            [errorContainerClassName]: !!error && errorContainerClassName
          })}
          className={cx({
            [className]: !!className,
            [errorClassName]: !!error && errorClassName
          })}
          checked={this.state.isChecked}
          onChange={this.onChange}
          onBlur={this.onBlur}
          type={this.props.type || 'text'}
          value={changedValue}
          hint={hint}
        />
      );
    }
  }
}
